<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@media (max-width: 320px) {
  html {
    font-size: 12px;
  }
}
@media screen and (min-width: 321px) and (max-width: 375px) {
  html {
    font-size: 12px;
  }
}

@media screen and (min-width: 376px) and (max-width: 414px) {
  html {
    font-size: 12px;
  }
}

@media screen and (min-width: 415px) and (max-width: 639px) {
  html {
    font-size: 14px;
  }
}

@media screen and (min-width: 640px) and (max-width: 719px) {
  html {
    font-size: 14px;
  }
}
/*  全屏 */
#app {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue